<template>
    <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
        <span>あめねこサンプルコード集</span>
        </router-link>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" v-bind:class="{ 'is-active': menuActive }" @click="menuToggle()" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        </a>
    </div>

    <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{ 'is-active': menuActive }">
        <div class="navbar-start">
            <a class="navbar-item">
                <router-link to="/"><i class="fas fa-home"></i> ホーム</router-link>
            </a>
        </div>

        <!-- <div class="navbar-end">
        <div class="navbar-item">
            <b-dropdown v-if="userStatus" position="is-bottom-left" aria-role="list">
                <button class="button is-info" outlined slot="trigger">
                    <span style="font-weight:bold;">設定</span>
                    <b-icon icon="menu-down"></b-icon>
                </button>

                <b-dropdown-item aria-role="listitem"><router-link to="/payment"><i class="far fa-credit-card"></i> メンバー登録</router-link></b-dropdown-item>
                <hr style="margin:4px;">
                <b-dropdown-item aria-role="listitem">
                    <b-button class="is-text" style="font-size:1em;padding:0px;font-weight:bold;" @click="logout">
                        ログアウト
                    </b-button>
                </b-dropdown-item>
            </b-dropdown>

            <a class="navbar-item">
                
            </a>
            <div class="buttons">
                <router-link to="login">
                    <b-button v-if="!userStatus" class="button is-info" style="font-weight:bold;">
                        ログイン
                    </b-button>
                </router-link> 
            </div>
        </div>
        </div> -->
    </div>
    </nav>
</template>

<script>
export default {
    data(){
        return{
            menuActive:false,
        }
    },
    watch:{
        '$route' () {
            this.menuActive = false
        }
    },
    methods:{
        menuToggle(){
            this.menuActive = !this.menuActive;
        },
    }
}
</script>

<style scoped>
nav{
    font-weight: bold;
    background-color:#F8F9FA;
}
</style>